import Header from '@/core/layouts/header/Header.tsx'
import { Box } from '@mui/material'
import HomeContainer from '@/modules/home/containers/HomeContainer.tsx'
import WelcomeModal from '@/modules/home/components/WelcomeModal.tsx'
import { useEffect, useMemo } from 'react'
import { BrowserStorage } from '@/core/utils/browserStorage.ts'

export const mainBarHeight = '74px'

const HomeLayout = () => {
  const isUserFirstTime = useMemo(() => {
    const resp = BrowserStorage.readFromSession('isUserFirstTime')
    return resp === null ? false : JSON.parse(resp)
  }, [])

  useEffect(() => {
    return () => BrowserStorage.removeSession('isUserFirstTime')
  }, [])

  return (
    <Box sx={{ height: '100%' }}>
      <Header showSideBtn={false} />
      <Box
        component="main"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          height: `calc(100vh - ${mainBarHeight})`
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '15px',
            maxWidth: '700px'
          }}
        >
          <HomeContainer />
        </Box>
      </Box>
      {isUserFirstTime && <WelcomeModal goToUrl="/teaching/videoList" />}
    </Box>
  )
}

export default HomeLayout
